module.exports = __webpack_public_path__ + "static/media/HCMM878.160419b4.jpg";